<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/reformToMaterial',title:'改制目录到物料'},{title:'改制物料审批'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form :model="saveData" label-position="right" ref="saveData" :inline="true"
                                 class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>改制物料审批</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine sp-rtm-form">
                                            <el-form-item label="产品编码" class="h-elformWrap-2">
                                                <el-input v-model="saveData.materialCode" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品名称" class="h-elformWrap-2">
                                                <el-input v-model="saveData.materialName" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="改制要求" class="h-elformWrap-2">
                                                <el-input v-model="saveData.specificReform" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="个性化定制标准描述" class="h-elformWrap-2">
                                                <el-input v-model="saveData.individualizeReform" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="是否只能生产改" class="h-elformWrap-2">
                                                <el-select v-model="saveData.onlyProduction" placeholder="请选择" disabled>
                                                    <el-option label="是" :value="1"></el-option>
                                                    <el-option label="否" :value="0"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="单台加价" class="h-elformWrap-2">
                                                <el-input v-model="saveData.reformPrice" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="改制技术要求" class="h-elformWrap-1">
                                                <el-input v-model="saveData.reformCountRequire" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="备注" class="h-elformWrap-1">
                                                <el-input v-model="saveData.remark" readonly></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>

                    <!-- 改制物料明细（子表） -->
                    <div class="h-rowBox ljjtablepaddings12" style="margin-top:20px;padding:0;">
                        <div class="h-rowCon" style="padding-bottom:0">
                            <div class="h-pieceIn2" style="padding-left:0.26rem;">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>改制物料明细</h1>
                                </div>
                            </div>
                            <el-table
                                ref="detailTable"
                                :data="saveData.detailList"
                                stripe
                                style="width: 100%"
                                :border="true">
                                <el-table-column type="index" width="50" label="#"></el-table-column>
                                <el-table-column prop="addMaterialCode" label="改制新增物料号" min-width="140" :show-overflow-tooltip="true"></el-table-column>
                                <el-table-column prop="addMaterialName" label="新增物料名称" min-width="140" :show-overflow-tooltip="true"></el-table-column>
                                <el-table-column prop="addMaterialOrder" label="新增物料单耗" min-width="120" :show-overflow-tooltip="true"></el-table-column>
                                <el-table-column prop="replaceMaterialCode" label="替换物料号" min-width="140" :show-overflow-tooltip="true"></el-table-column>
                                <el-table-column prop="replaceMaterialName" label="替换物料名称" min-width="140" :show-overflow-tooltip="true"></el-table-column>
                                <el-table-column prop="replaceMaterialOrder" label="替换物料单耗" min-width="120" :show-overflow-tooltip="true"></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 审批意见 -->
            <div class="h-row">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>审批意见</h1>
                                </div>
                                <div class="h-formLine sp-rtm-form">
                                    <el-form :model="saveData" label-position="right" :inline="true"
                                             class="demo-ruleForm h-formbLine h-formbLine1">
                                        <el-form-item label="审批意见" class="h-elformWrap-1" :required="true">
                                            <el-input v-model="shpyj" placeholder="请输入" :disabled="taskstatus == '1'"></el-input>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>

            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
                <el-button v-if="taskstatus != '1'" class="h-btn h-bBtn h-bgred" @click="auditFail">驳回</el-button>
                <el-button v-if="taskstatus != '1'" class="h-btn h-bBtn h-bggreen" @click="auditPass">通过</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="viewpress">审批跟踪</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import reformToMaterial from "@/api/reformToMaterial/reformToMaterial";

    export default {
        data() {
            return {
                showhistory: false,
                id: '',
                taskid: null,
                instid: null,
                taskstatus: null,
                shpyj: '',
                saveData: {
                    materialCode: '',
                    materialName: '',
                    specificReform: '',
                    individualizeReform: '',
                    onlyProduction: null,
                    reformPrice: '',
                    reformCountRequire: '',
                    remark: '',
                    detailList: [],
                },
            }
        },
        created() {
            this.id = this.$route.query.ywid || this.$route.query.id || '';
            this.taskid = this.$route.query.taskid;
            this.instid = this.$route.query.instid;
            this.taskstatus = this.$route.query.taskstatus;
            if (this.id) {
                this.getDetail(this.id);
            }
        },
        methods: {
            // 获取详情
            getDetail(id) {
                reformToMaterial.selectById(id).then(rd => {
                    if (rd.obj !== null && rd.obj !== undefined) {
                        this.saveData = rd.obj;
                        if (!this.saveData.detailList || this.saveData.detailList.length === 0) {
                            this.$set(this.saveData, 'detailList', []);
                        }
                        if (!this.instid) {
                            this.instid = rd.obj.instid;
                        }
                    }
                })
            },
            // 返回
            backS() {
                this.$router.go(-1);
            },
            // 审批跟踪
            viewpress() {
                this.showhistory = true;
            },
            // 驳回
            auditFail() {
                if (!this.shpyj) {
                    this.$msg.msge("驳回必须输入审批意见！");
                    return;
                }
                this.$msg.confirm("确认驳回？", () => {
                    this.submitForm('驳回');
                })
            },
            // 通过
            auditPass() {
                this.$msg.confirm("确认通过？", () => {
                    this.submitForm('通过');
                })
            },
            // 提交审批(通过/驳回)
            submitForm(optflag) {
                var params = {
                    id: this.id,
                    taskid: this.taskid,
                    optflag: optflag,
                    shpyj: this.shpyj,
                };
                reformToMaterial.shenpi(params).then(rd => {
                    this.$msg.alerts("审批成功！", () => {
                        //刷新右上角的待办个数
                        this.$store.dispatch("searchTasktotal");
                        //跳转回原页面
                        this.$router.go(-1);
                    })
                })
            },
        },
    }
</script>

<style>
    .sp-rtm-form .h-elformWrap-2 {
        width: 33.333% !important;
        padding-right: 0.5rem;
    }

    .sp-rtm-form .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem;
    }

    .sp-rtm-form .h-elformWrap-2 .el-form-item__label {
        width: 45%;
        text-align: right;
    }

    /*必须同时设置内容区宽度,否则输入框放不下会换行到label下面*/
    .sp-rtm-form .h-elformWrap-2 .el-form-item__content {
        width: 55%;
    }

    .sp-rtm-form .h-elformWrap-1 .el-form-item__label {
        width: 14%;
    }

    .sp-rtm-form .h-elformWrap-1 .el-form-item__content {
        width: 86%;
    }

    .sp-rtm-form .el-form-item__content .el-select {
        width: 100%;
    }
</style>
